import diagnostics from "../../Assets/diagnostics.png";
import couch from "../../Assets/couch.png";
import Repertoire1 from "../../Assets/Repertoire1.png";
import Repertoire2 from "../../Assets/Repertoire2.png";
import Repertoire3 from "../../Assets/Repertoire3.png";
import Repertoire4 from "../../Assets/Repertoire4.png";
import Repertoire5 from "../../Assets/Repertoire5.png";
import Repertoire6 from "../../Assets/Repertoire6.png";
import Repertoire7 from "../../Assets/Repertoire7.png";
import Repertoire8 from "../../Assets/Repertoire8.png";
import Repertoire9 from "../../Assets/Repertoire9.png";
import Repertoire10 from "../../Assets/Repertoire10.png";
import Repertoire11 from "../../Assets/Repertoire11.png";
import func1 from "../../Assets/func1.png";
import func2 from "../../Assets/func2.png";
import func3 from "../../Assets/func3.png";
import func4 from "../../Assets/func4.png";
import precisionimg from "../../Assets/precision-img.png";
import edge1 from "../../Assets/edge1.png";
import edge2 from "../../Assets/edge2.png";
import edge3 from "../../Assets/edge3.png";
import edge4 from "../../Assets/edge4.png";
import benefit1 from "../../Assets/benefit1.png";
import benefit2 from "../../Assets/benefit2.png";
import benefit3 from "../../Assets/benefit3.png";
import benefit4 from "../../Assets/benefit4.png";
import vamshi from "../../Assets/vamshi.png"
import swathi from "../../Assets/swathi.png"
import girimohan from "../../Assets/girimohan.png"

export const serviceShowcaseData = [
  {
    imgSrc: diagnostics,
    title: `Your Home, Our Expertise\n Comfort Meets \nPrecision Diagnostics`,
    buttonText: "Book Now",
    onButtonClick: () => console.log("Button Clicked"),
  },
];

export const diagnostics_couch_data = {
  title: `From Lab To Couch`,
  para1: `Imagine having the convenience of laboratory-quality diagnostics without ever leaving the comfort of your home. With our innovative service, we make that a reality.`,
  para2: `Whether it's a simple blood draw or more complex diagnostics, we ensure minimal discomfort and maximum accuracy.`,
  image: couch,
};

export const Repertoireheading = `Our Repertoire Of Services`;
export const RepertoireServices = {
  o1: { title: "Complete Blood Picture", img: Repertoire1 },
  o2: { title: "Blood Sugar Levels", img: Repertoire2 },
  o3: { title: "Liver Function Tests", img: Repertoire3 },
  o4: { title: "Kidney Function Tests", img: Repertoire4 },
  o5: { title: "Thyroid Function Tests", img: Repertoire5 },
  o6: { title: "Cardiac Markers", img: Repertoire6 },
  o7: { title: "Serum Electrolytes", img: Repertoire7 },
  o8: { title: "Lipid Profile", img: Repertoire8 },
  o9: { title: "Urinalysis", img: Repertoire9 },
  o10: { title: "Allergy Panel", img: Repertoire10 },
  o11: { title: "Vitamin Panel", img: Repertoire11 },
};

export const functionheading = `How We Function`;
export const functionServices = {
  o1: { title: "Book A Test", img: func1 },
  o2: { title: "Sample Pick Up", img: func2 },
  o3: { title: "Analysis", img: func3 },
  o4: { title: "Download Reports", img: func4 },
};

export const chooseexcellence_data = {
  title: `Precision in Every Sample`,
  subheading: `Analysis You Can Trust `,
  para1: `We utilize the latest equipment and technology to perform our tests, ensuring high precision and reliability in every analysis.`,
  para2: `Your health and well-being are our top priorities. We know that time is of the essence, which is why we strive to deliver results promptly, without compromising on accuracy.`,
  image: precisionimg,
};

export const edgeheading = `Our Competitive Edge`;
export const edgeServices = {
  o1: { title: "Certified Phlebotomist", img: edge1 },
  o2: { title: "Quality Compliance", img: edge2 },
  o3: { title: "Expert Verified", img: edge3 },
  o4: { title: "NABL Accredited", img: edge4 },
};

export const benefitheading = `Who May Benefit`;
export const benefitServices = {
  o1: { title: "Elderly", img: benefit1 },
  o2: { title: "Chronically Ill", img: benefit2 },
  o3: { title: "Post Surgery Recovery", img: benefit3 },
  o4: { title: "Bedridden", img: benefit4 },
};

//testimoonial data
export const diagnostics_testimonials = [
  {
    title: `See Why Everyone's Excited`,
    desc: `As someone with a busy schedule, having the option to get my tests
done at home was a game changer. At Wihan, the process was 
seamless, and the results were accurate.`,
    userimg: vamshi,
    username: "Vamshi Krishan",
  },
  {
    title: `See Why Everyone's Excited`,
    desc: `I was a bit skeptical about home diagnostics at first. The convenience
of not having to go to a lab or clinic made all the difference. Will 
definitely use this wihan services again and recommend them for any
kind of home health assisted services.`,
    userimg: swathi,
    username: "Swathi Netha",
  },
  {
    title: `See Why Everyone's Excited`,
    desc: `I was impressed by the level of care and attention to detail during my 
home diagnostic test. The staffs at wihan were very professional, 
and the results were delivered promptly.`,
    userimg: girimohan,
    username: "Giri Mohan",
  },
];
